module.exports = __webpack_public_path__ + "static/media/tiktok.f5defd96.svg";